module.exports = __webpack_public_path__ + "img/user-default.9fea8b5e.png";